import { Vue } from "vue-property-decorator";

// We will need to define extended vue class with our custom properties to provide correct type
export default class VueExt extends Vue {
  $baseWebsite!: string;
}
